import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import router from './router'

import './assets/styles/index.css';
import './mixins/typography';

Vue.use(VueAnalytics, {
  id: 'UA-172344746-1'
})

/*<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-172344746-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-172344746-1');
</script>*/

Vue.config.productionTip = false
/*
const routes = {
  '/': Landing,
  '/login': Login,
  '/signup/indie': SignUpIndie,
  '/join_us': JoinUs,
  '/service': ServiceDetails,
  '/service/cost': ServiceCost,
  '/service/form': ServiceForm,

  '/worker': WorkerHome,
  '/worker/blank': WorkerBlank,
  '/worker/profile/edit': EditProfile,
  '/service/create': CreateService
}*/

Vue.use(VueToast);

Vue.use(VueRouter)

new Vue({
  router
}).$mount('#app')